import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

interface WorkBadgeEmailSuccessBottomSheetProps {
  modalState: UseModalState;
  primaryButtonText: string;
  onPrimaryButtonClick: () => void;
}

export function WorkBadgeEmailSuccessBottomSheet(props: WorkBadgeEmailSuccessBottomSheetProps) {
  const worker = useDefinedWorker();
  const { modalState, primaryButtonText, onPrimaryButtonClick } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" size="large" onClick={onPrimaryButtonClick}>
            {primaryButtonText}
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="request-sent"
        title="Your Work Badge is in your email"
        description={`We sent your badge with print-out instructions to ${worker.email}`}
      />
    </BottomSheet>
  );
}
